import styled from "@emotion/styled";

export const Image = styled.img`
  width: 100%;
  margin-top: 17px;
`